import get from 'transmute/get';
import UILink from 'UIComponents/link/UILink';
import PortalIdParser from 'PortalIdParser';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { getEmailEditConfigurationUrl } from '../../../urls/inboxSettingsUrls';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
// @ts-expect-error module not typed
import { getEmail } from 'conversations-internal-schema/connected-email-account/operators/connectedEmailAccountGetters';
import { getId, getConnectedAccountContext, getMarketingEmailContext, getSubject, getCampaignId, getCampaignGroupId
// @ts-expect-error module not typed
} from 'conversations-message-history/context-update/operators/contextUpdateGetters';
import { useConnectedAccounts } from 'conversations-thread-data/connected-accounts/public';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { InfoIcon } from 'foundations-assets';
// @ts-expect-error module not typed
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import SystemMessage from 'conversations-inbox-message-history/system-message/SystemMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ConnectedAccountContextSystemUpdate = ({
  inboxId,
  message
}) => {
  const {
    asyncConnectedAccounts
  } = useConnectedAccounts({
    inboxId
  });
  const connectedAccountContext = getConnectedAccountContext(message);
  const marketingEmailContext = getMarketingEmailContext(message);
  const emailId = getId(connectedAccountContext);
  const connectedAccounts = getData(asyncConnectedAccounts);
  if (connectedAccounts) {
    const connectedAccount = get(`${emailId}`, connectedAccounts);
    const email = getEmail(connectedAccount);
    if (connectedAccount) {
      const connectedAccountLink = /*#__PURE__*/_jsx(UILink, {
        href: getEmailEditConfigurationUrl({
          inboxId,
          emailId
        }),
        external: true,
        use: "blue",
        children: email
      });
      if (marketingEmailContext) {
        const marketingSubject = getSubject(marketingEmailContext);
        const campaignId = getCampaignId(marketingEmailContext);
        const campaignGroupId = getCampaignGroupId(marketingEmailContext);
        return /*#__PURE__*/_jsx(SystemMessage, {
          timestamp: getTimestamp(message),
          description: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "conversations-thread-view.threadHistory.context-update-message.marketingEmail",
            options: {
              marketingEmail: /*#__PURE__*/_jsx(UILink, {
                href: `/email/${PortalIdParser.get()}/campaign/${campaignGroupId || campaignId}`,
                external: true,
                use: "blue",
                children: marketingSubject
              }),
              connectedAccount: connectedAccountLink
            }
          }),
          icon: /*#__PURE__*/_jsx(IconCircle, {
            borderWidth: "0",
            icon: InfoIcon,
            size: "500"
          })
        });
      }
      return /*#__PURE__*/_jsx(SystemMessage, {
        timestamp: getTimestamp(message),
        description: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "conversations-thread-view.threadHistory.context-update-message.connectedAccount",
          options: {
            connectedAccount: connectedAccountLink
          }
        }),
        icon: /*#__PURE__*/_jsx(IconCircle, {
          borderWidth: "0",
          icon: InfoIcon,
          size: "500"
        })
      });
    }
  }
  return /*#__PURE__*/_jsx(SystemMessage, {
    timestamp: getTimestamp(message),
    description: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-thread-view.threadHistory.context-update-message.unknownSourceMessage'
    }, 'chatflow-source-message'),
    icon: /*#__PURE__*/_jsx(IconCircle, {
      borderWidth: "0",
      icon: InfoIcon,
      size: "500"
    })
  });
};
ConnectedAccountContextSystemUpdate.displayName = 'ConnectedAccountContextSystemUpdate';
export default ConnectedAccountContextSystemUpdate;